import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
export const db = firebase
    .initializeApp({
      apiKey: "AIzaSyAUMLhQMNkeuoC2Pxu0b4QUSULCDgN_HHU",
      authDomain: "prenota-31090.firebaseapp.com",
      projectId: "prenota-31090",
      storageBucket: "prenota-31090.appspot.com",
      messagingSenderId: "924727715373",
      appId: "1:924727715373:web:93286441a7a2a92285baa4",
      measurementId: "G-DJ3L14D8BB"
    })
    .firestore()

// Export types that exists in Firestore
const { Timestamp, GeoPoint } = firebase.firestore
export { Timestamp, GeoPoint }